// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"320":"54910ca4","363":"483e2b96"}[chunkId] + ".js";
};